import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import SpecList from './pages/SpecList';
import SpecFlow from './pages/SpecFlow';
import Learn from './pages/Learn';
import Governance from './pages/Governance';
import Observe from './pages/Observe';
import Work from './pages/Work';
import Security from './pages/Security';
import Admin from './pages/Admin';
import ForgeShell from './components/ForgeShell';
import CreatorMark from './components/CreatorMark';
import CertificateVerify from './pages/CertificateVerify';
import Profile from './pages/Profile';
import Readiness from './pages/Readiness';
import ExecutionWorkspace from './pages/ExecutionWorkspace';

// Wrapper that redirects unauthenticated users to the login page.
// Shows a loading spinner while the session check is in progress.
function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="app-loading">Loading…</div>;
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function LegacyWorkRedirect({ section }) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  params.set('section', section);
  return <Navigate to={`/work?${params.toString()}`} replace />;
}

function App() {
  return (
    <AuthProvider>
      <div className="app">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/certificates/verify/:code" element={<CertificateVerify />} />
          <Route element={<RequireAuth><ForgeShell /></RequireAuth>}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/learn" element={<Learn />} />
            <Route path="/readiness" element={<Readiness />} />
            <Route path="/govern" element={<Governance />} />
            <Route path="/observe" element={<Observe />} />
            <Route path="/work" element={<Work />} />
            <Route path="/secure" element={<Security />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/board" element={<LegacyWorkRedirect section="build" />} />
            <Route path="/specs" element={<SpecList />} />
            <Route path="/specs/:sessionId" element={<SpecFlow />} />
            <Route path="/project-spine" element={<LegacyWorkRedirect section="define" />} />
            <Route path="/execution" element={<ExecutionWorkspace />} />
          </Route>
        </Routes>
        <CreatorMark />
      </div>
    </AuthProvider>
  );
}

export default App;
